import { type FileUploadProps } from '@gov-nx/core/hooks';

export const PPPZapisUploadParameters: FileUploadProps = {
	extensions: [
		'.doc',
		'.docx',
		'.gif',
		'.isdoc',
		'.isdocx',
		'.jfif',
		'.jpeg',
		'.jpg',
		'.mp2',
		'.mp3',
		'.mpeg1',
		'.mpeg2',
		'.pdf',
		'.png',
		'.ppt',
		'.pptx',
		'.rtf',
		'.tif',
		'.tiff',
		'.txt',
		'.wav',
		'.xls',
		'.xlsx',
		'.xml',
		'.zfo',
	],
	maxAttachments: 20,
	maxFileSize: 20 * 1024 * 1024,
	maxSumFileSize: 20 * 1024 * 1024,
	multiple: true,
};

export enum PPPTypeOptions {
	empty = '',
	PodnetKDoplneniSeznamu = 'PodnetKDoplneniSeznamu',
}
